<template>
    <div class="fzg-about-pc">
      <div class="fzg-banner">
        <fzg-menu/>
      </div>
      <div class="section fzg-about-intro">
        <img class="eco-title" src="../../assets/img2/pc/about/fzg-about-title-intro.png" alt="">
        <div class="intro-title-line"></div>
        <div class="intro-content">
          <div class="left">
            <img class="logo" src="../../assets/img2/pc/about/fzg-about-logo.jpg">
          </div>
          <div class="right">
            <p>凡卓集团成立于2014年，依托独有的创投生态体系，扎根产业实体。面向高质量的科创城市、创业者、机构投资者、产业专家、行业从业者、科创巨头企业，提供财务顾问、直接投资、创业孵化、创投媒体、产业咨询、商机对接、创投培训、路演论坛、飞地运营等服务。 </p>
            <br>
            <p>凡卓集团的使命是“帮助创业者找人、找钱、找产业政策”，旗下包含小饭桌创服、小饭桌创投、凡卓资本三个板块，其中凡卓资本累计帮助近600家企业完成超800亿元融资，近两年内帮助数百个明星项目完成近300亿元融资。 </p>
          </div>
        </div>
        <div class="intro-profile">

          <div class="pro-item-list" v-if="false">
            <div class="pro-item">
            </div>
            <div class="pro-item">
              <div class="title">2022年度中国企业服务领域财务顾问 TOP 2</div>
              <div class="line"></div>
              <div class="name">企名片</div>
            </div>
            <div class="pro-item">
              <div class="title"> 2022年度中国最佳财务顾问综合榜 TOP 4 </div>
              <div class="line"></div>
              <div class="name">企名片</div>
            </div>

            <div class="pro-item" v-for="i in 1 ">
              <div class="title"> 2022中国最具影响力新型投行 TOP 5 </div>
              <div class="line"></div>
              <div class="name">36氪</div>
            </div>
          </div>

          <div class="pro-item-list swiper-container profileSwiper">
            <div class="pro-item swiper-wrapper">
              <div class="swiper-slide pro-swiper-item" v-for="item in profileData">
                <div class="title">{{ item.title }}</div>
                <div class="line"></div>
                <div class="name">{{ item.source }}</div>
              </div>
            </div>
          </div>


          <div class="profile-arrow-line">
            <div class="aa-left" @click="onClickLeftSwiper()"></div>
            <div class="aa-right" @click="onClickRightSwiper()"></div>
          </div>

        </div>
      </div>


      <div class="section fzg-teams-g4">
        <img class="team-title" src="../../assets/img2/pc/about/fzg-about-title-core-team.png" alt="">
        <div class="team-data">
          <div class="person-item" @click="showPartner(0)"></div>
          <div class="person-item" @click="showPartner(1)"></div>
          <div class="person-item" @click="showPartner(2)"></div>
          <div class="person-item" @click="showPartner(3)"></div>

        </div>
      </div>

      <div class="fzg-advantage">
        <img class="title-business" src="../../assets/img2/pc/about/fzg-about-title-advantage.png" alt="">
        <div class="advantage-area">
          <div class="bus-item">
            <img class="bus-icon" src="../../assets/img2/pc/about/about-advantage-1.png" alt="">
            <div class="bus-title">深耕案源</div>
            <div class="sub-title">结构性覆盖产业关键节点<br>批量导入、准确研判</div>
            <div class="bus-content">
              <b> 小饭桌新媒体：</b>创投圈最具影响力的小饭桌新媒体全力协助融资
              <div class="line"></div>
              <b> 媒体联盟：</b>与国内近百家党政媒体、财经媒体及科技行业垂直媒体保持紧密合作；与十余家业内专业的创投媒体形成合作矩阵
              <div class="line"></div>
              <b>产业资金：</b>4000家活跃机构18000位产业投资人
              <div class="line"></div>
              <b>产业资产：</b>世界、国内500强企业矩阵式合作关系，从集团到控股子公司深度协同
              <br><br>
            </div>
          </div>
          <div class="bus-item">

            <div class="bus-title">深入一线</div>
            <div class="sub-title">一线地域布局 <br> 一线认知力、一线资源库 </div>
            <div class="bus-content">
              <b> 资金注入：</b>协同政府引导基金及子基金，投资与当地产业链配套的优秀企业
              <div class="line"></div>

              <b> 政策支持：</b>帮助政府进行创投名片打造、投后管理及招商引资工作，熟知各地一手落地政策信息

              <div class="line"></div>
              <b> 产学一体：</b>战略合作多所顶级高校、科研院所

              <div class="line"></div>
              <b> 专家顾问：</b>创业营签约独角兽公司CEO、百余位专家院士入库
              <br><br><br><br>

            </div>
            <img class="bus-icon" src="../../assets/img2/pc/about/about-advantage-2.png" alt="">
          </div>
          <div class="bus-item">
            <img class="bus-icon" src="../../assets/img2/pc/about/about-advantage-3.png" alt="">
            <div class="bus-title">深度闭环</div>
            <div class="sub-title">夥伴共荣闭环<br> 企业内生与外延闭环、区域价值流转闭环</div>
            <div class="bus-content">
              <b>长期陪伴的产业财务顾问：</b>从项目伊始到上市规划的长线服务，前瞻性思考、全局性谋划

              <div class="line"></div>
              <b> 企业业务发展战略咨询：</b> 对接生产资料资源、业务增长的发展建议，引荐客户、匹配产业链上下游业务合作

              <div class="line"></div>
              <b>产业升级：</b>深入到区与县一级的产业链中推动质量变革、效率变革、动力变革

              <div class="line"></div>
              <b>项目落地：</b> 运用投研力量与数据禀赋，精准对接项目与承载区域
            </div>
          </div>
        </div>
      </div>



      <div class="section fzg-history">
        <img class="eco-title" src="../../assets/img2/pc/about/fzg-about-title-history.png" alt="">
        <div class="eco-data"></div>
      </div>

      <transition name="fade">
        <fzg-about-partner-modal
          v-if="isShowPartnerModal"
          :partner-index="partnerIndex"
          @hide-modal="isShowPartnerModal = false"/>
      </transition>

    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgAboutPartnerModal from './FzgAboutPartnerModal.vue'
import FzgMenu from '../common/FzgMenu.vue'

export default{
    components:{
      FzgMenu,
      FzgAboutPartnerModal,
    },
    props:[''],
    data(){
        return{
          isShowPartnerModal: false,
          partnerIndex: 0,
          profileSwiper: '',
          profileData: [
            {
              title: "2022年度中国新能源领域财务顾问 TOP 1",
              source: "企名片"
            },
            {
              title: "2022年度中国企业服务领域财务顾问 TOP 2",
              source: "企名片"
            },
            {
              title: "2022年度中国最佳财务顾问综合榜 TOP 4",
              source: "企名片"
            },
            {
              title: "2022中国最具影响力新型投行 TOP 5",
              source: "36氪"
            },
            {
              title: "2022硬科技 FA 榜",
              source: "科创板日报"
            },
            {
              title: "2022年度FA先锋TOP 5",
              source: "钛媒体"
            },
            {
              title: "2022中国一级市场FA活跃度TOP 5",
              source: "IT桔子"
            },
            {
              title: "2022年度中国医疗健康财务顾问交易量卓越榜",
              source: "IT桔子"
            },
            {
              title: "2022最佳FA机构",
              source: "母基金研究中心"
            },
            {
              title: "2022硬科技精品投行",
              source: "亿欧"
            },
            {
              title: "WISE2022新经济之王-最具影响力新型投行TOP 5",
              source: "36氪"
            },
            {
              title: "2021年河南洪涝灾害救援扶贫基金捐赠",
              source: "中国扶贫基金会"
            },
            {
              title: "WISE2021新经济之王-最具影响力新型投行TOP 10",
              source: "36氪"
            },
            {
              title: "2021财务顾问机构-综合财务顾问机构榜TOP 30",
              source: "企名片"
            },
            {
              title: "WISE2020中国最具影响力新型投行TOP 10",
              source: "36氪"
            },
            {
              title: "WISE2020中国最具成长力早期投资机构TOP 10",
              source: "36氪"
            },
            {
              title: "2019年度中国最佳FA机构TOP 10",
              source: "企名片"
            },
            {
              title: "2019未来医疗100强榜-年度FA机构TOP 5",
              source: "动脉网"
            },
            {
              title: "2019年中国企业服务领域财务顾问机构10强-TOP 1",
              source: "企名片"
            },
            {
              title: "WISE2019-中国最具影响力新型投行TOP 10",
              source: "36氪"
            }
          ]

        }
    },
    methods:{
      initActivitySwiper() {
        var self = this
        $(function() {
          self.profileSwiper = new Swiper(".profileSwiper", {
            slidesPerView: 4,
            centeredSlides: false,
            loop: true,
            loopFillGroupWithBlank: true,
            spaceBetween: 30,
            slidesPerGroup: 4,
            autoplay: {
              delay: 5000,
            },
          });
        })
      },

      onClickRightSwiper(){
        this.profileSwiper.slideNext(200, '')
      },
      onClickLeftSwiper(){
        this.profileSwiper.slidePrev(200, '')
      },
      showPartner(index) {
        this.isShowPartnerModal = true
        this.partnerIndex = index
      }
    },
    mounted(){
      this.initActivitySwiper()
    },
    watch: {
      'fzTeamList': function() {
      },
    },

}
</script>

<style lang="scss">
.fzg-about-pc {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/about/banner.png) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266448098/us-bn.png) no-repeat;
    background: url(https://static-image.xfz.cn/1687734795317/about_banner.png) no-repeat;
    background-size: auto;
    background-position: bottom;

    height: 340px;
    position: relative;
  }
  .fzg-about-intro {
    // border: 1px solid red;
    height: 950px;
    margin: 0 auto;
    position: relative;
    .eco-title {
      width: 190px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 75px;
      margin-left: -95px;
      // border: 1px solid #ce262f;
    }
    .intro-title-line {
      position: absolute;
      left: 50%;
      right: 0;
      top: 190px;
      width: 80px;
      height: 4px;
      margin-left: -40px;
      background-color: #ce262f;
    }
    .intro-content {
      // border: 1px solid black;
      width: 1100px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 220px;
      margin-left: -550px;
      .left {
        // border: 1px solid #ce262f;
        display: inline-block;
        vertical-align: top;
        width: 400px;
        height: 200px;
        margin-top: 70px;
        .logo {
          width: 100%;
        }
      }
      .right {
        // border: 1px solid green;
        display: inline-block;
        width: 690px;
        height: 300px;
        text-align: justify;
        padding: 20px 10px;
        p {
          // font-family: SourceHanSansCN-Medium;
          font-size: 19px;
          line-height: 1.6;
          color: #221c0e;
        }
      }
    }
    .intro-profile {
      // border: 1px solid red;
      width: 1100px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 600px;
      margin-left: -550px;
      .pro-item-list {
        // border: 1px solid red;
        .pro-item {
          // border: 1px solid #ccc;
          // width: 250px;
          // height: 220px;
          padding: 20px 0px;
          background: #ececec;
          .pro-swiper-item {
            // border: 1px solid #ccc;
            background: #ececec;
            // width: 180px;
            height: 220px;
            text-align: left;
            padding: 20px;
            .title {
              font-size: 19px;
              line-height: 1.5;
              // border: 1px solid red;
              height: 100px;
              margin-top: 8px;
            }
            .line {
              width: 60px;
              border: 2px solid #be1717;
              margin: 15px 0 15px;
            }
            .name {
              font-size: 20px;
            }
          }
        }
      }
      .profile-arrow-line {
        // border: 1px solid red;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        .aa-left {
          // border: 1px solid red;
          width: 28px;
          height: 28px;
          background: url(../../assets/img2/pc/about/ab-arrow-left.png) no-repeat;
          background-size: 100%;
          // transform: rotate(180deg);
          cursor: pointer;
          display: inline-block;
        }
        .aa-right {
          // border: 1px solid red;
          width: 28px;
          height: 28px;
          background: url(../../assets/img2/pc/about/ab-arrow-right.png) no-repeat;
          background-size: 100%;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
  .fzg-teams-g4 {
    // border: 1px solid red;
    height: 850px;
    margin: 0 auto;
    position: relative;
    .team-title {
      width: 180px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 100px;
      margin-left: -545px;
      // border: 1px solid #ce262f;
    }
    .team-data {
      background-image: url(../../assets/img2/pc/about/fzg-about-g4.png);
      background-size: contain;
      background-repeat: no-repeat;
      width: 1100px;
      height: 500px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 250px;
      margin-left: -570px;
      // border: 1px solid #ce262f;
      .person-item {
        // border: 1px solid red;
        width: 24.2%;
        height: 100%;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
  .fzg-advantage {
    position: relative;
    height: 1000px;
    // border: 1px solid green;
	  background-color: white;
    .title-business {
      width: 160px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0px;
      margin-left: 385px;
      // border: 1px solid #ce262f;
    }
    .advantage-area {
      // border: 1px solid red;
      width: 1100px;
      height: 500px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 120px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      margin-left: -550px;
      .bus-item {
        width: 344px;
        // border: 1px solid #ccc;
        background: #f2f2f2;
        // box-shadow: 1px 5px 24px 0px #ededed;
        text-align: left;
        .bus-icon {
          width: 100%;
          display: block;
        }
        .line {
          width: 98%;
          border-bottom: 1px solid #7a7a7a;
          margin: 15px auto;
        }
        .bus-title {
          font-size: 24px;
          font-weight: bold;
          margin-top: 40px;
          margin-left: 20px;
          color: #be1717;
        }
        .sub-title {
          // border: 1px solid #ccc;
          font-size: 17px;
          margin-top: 15px;
          margin-right: 15px;
          margin-left: 20px;
          color: #d7ad78;
        }
        .bus-content {
          font-size: 16px;
          text-align: justify;
          margin-top: 20px;
          line-height: 20px;
          padding: 20px;
          line-height: 1.5;
        }
      }
    }
  }
  .fzg-history {
    // border: 1px solid red;
    height: 800px;
    margin: 0 auto;
    position: relative;
    .eco-title {
      width: 190px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0px;
      margin-left: -540px;
      // border: 1px solid #ce262f;
    }
    .eco-data {
      // background-image: url(../../assets/img2/pc/about/fzg-about-history.png);
      // background-image: url(https://static-image.xfz.cn/1686408103219/about-journey.jpg);
      // background-image: url(https://static-image.xfz.cn/1697974343152/about-jn.jpg);
      background-image: url(https://static-image.xfz.cn/1698580443219/about_us.jpg);
      background-size: contain;
      background-repeat: no-repeat;
      // width: 100%;
      width: 1400px;
      height: 600px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 100px;
      margin-left: -700px;
      // border: 1px solid #ce262f;
      display: block;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

}
</style>



// WEBPACK FOOTER //
// FzgAboutPc.vue?2840233d